import DatePickerRange from 'components/PeriodSelection/DatePickerRange';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import contractServices from './contractServices';
import DeleteDialogueBox from 'components/Common/deleteDialogue';
import { Filter } from 'filter';
import { CommonUtilities } from 'commonUtils';
import Pagination from 'components/Common/newPagination';

export default function ContractNotes(param: any) {

    let [filterVal, setFilterVal] = useState('');
    let [deleteNoteData, setDeleteNoteData] = useState<any>([]);
    let [deleteNoteStatus, setDeleteNoteStatus] = useState(false);
    let [noteDetails, setnoteDetails] = useState<any>([]);
    let [contractNoteRow, setcontractNoteRow] = useState(0);
    let [contractNoteList, setcontractNoteList] = useState<any>([]);
    let [contractSectionType, setcontractSectionType] = useState("All");
    let [contractNoteListTemp, setcontractNoteListTemp] = useState<any>([]);


    useEffect(() => {
        setnoteDetails({ ...noteDetails, contractRefNum: param?.selectedMainWizard?.contractRefNum })
        loadContractNotes("All");
    }, []);

    const actionDateSelection = (e: any) => {
        if (e !== null) {
            console.log(e)
            console.log(Filter.DateTimeFormat(e))
            setnoteDetails({ ...noteDetails, notesActionDate: Filter.DateTimeFormat(e) })
        }
    }

    const startDateSelection = (e: any) => {
        if (e !== null) {
            console.log(e)
            console.log(Filter.DateTimeFormat(e))
            setnoteDetails({ ...noteDetails, notesStartDate: Filter.DateTimeFormat(e) })
        }
    }

    const loadContractNotes = (noteType: any) => {
        contractSectionType = noteType
        setcontractSectionType(contractSectionType)
        var payload = {
            contractSection: contractSectionType == "All" ? "" : contractSectionType,
            contractrefnum: param?.selectedMainWizard?.contractRefNum

        }
        contractServices.contractNote(payload).then((respond: any) => {
            contractNoteList = respond;
            setcontractNoteList(contractNoteList)

            contractNoteListTemp = respond;
            setcontractNoteListTemp(contractNoteList)

            contractNoteRow = respond?.[0]?.totalRows ?? 0;
            setcontractNoteRow(contractNoteRow)
        })
    }

    const closeDrawer = () => {
        param.onChangContractNote();
    }

    const editContractNote = (note: any) => {
        noteDetails = note;
        setnoteDetails(noteDetails)
    }

    const deleteContractNote = (note: any) => {
        deleteNoteData = note
        setDeleteNoteData(deleteNoteData);

        deleteNoteStatus = true;
        setDeleteNoteStatus(deleteNoteStatus)
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            contractServices.contractNoteDelete(deleteNoteData.notesId).then((res: any) => {
                if (res) {
                    CommonUtilities.showToastDawer('Contract Note delete Successfull', 'Success')
                }
            })
        }

        deleteNoteStatus = false;
        setDeleteNoteStatus(deleteNoteStatus)
    }

    const SaveContractNote = () => {

        if (FormValidation()) {
            contractServices.contractNoteSave(noteDetails).then((res: any) => {
                if (res) {
                    CommonUtilities.showToastDawer('Contract Note Save Successfull', 'Success')
                }
            })
        }
    }

    const ResetContractNote = () => {
        noteDetails = [];
        setnoteDetails(noteDetails)

        setnoteDetails({ ...noteDetails, contractRefNum: param?.selectedMainWizard?.contractRefNum })
    }

    const filterSearch = (searchfor: any) => {

        console.log(searchfor)
        filterVal = searchfor
        setFilterVal(filterVal)

        if (searchfor.length > 0) {
            var searchListing = contractNoteListTemp.filter((list: any) => list.contractNotes.includes(searchfor) || list.contractClause.includes(searchfor) || list.contractSection.includes(searchfor))
            console.log(searchListing)
            contractNoteList = searchListing;
            setcontractNoteList(contractNoteList);
        }
    }

    const FormValidation = () => {
        let valid = false;

        const ContractRefNum: any = document.getElementById("ContractRefNum");
        const contractNotes: any = document.getElementById("contractNotes");

        if (!noteDetails?.contractRefNum) {
            ContractRefNum.style.border = "1px solid #e50e0e";

        }
        if (!noteDetails?.contractNotes) {
            contractNotes.style.border = "1px solid #e50e0e";
        }

        if (noteDetails?.contractRefNum && noteDetails?.contractNotes) {
            valid = true;
        } else {
            CommonUtilities.showToastDawer('There was a problem submitting your request, one or more fields are missing or incorrect', 'fail')
        }

        return valid;
    }
    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        export: 0,
        searchFor: '',
        sortBy: '',
        sortOrder: '',
        additionalInfo: "Status"
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
    }

    return (
        <>
            <Drawer
                open={param.noteOpen}
                onClose={closeDrawer}
                direction='right'
                className='react-drawer allowHscroll allowVscroll'
                size={800}>

                <div className='ws-7 pull-right box'>
                    <div className="box-header-main well">
                        <h2 > </h2>
                    </div>

                    <div className="box-content">

                        <div className="form-format ws-12">
                            <label className="control-label">Contract Ref No.*</label>
                            <div className="label-entries">
                                <input type="text" className="text-uppercase " placeholder="Enter contract ref" value={noteDetails?.contractRefNum ?? ""}
                                    onChange={(e: any) => setnoteDetails({ ...noteDetails, contractRefNum: e.target.value })} required name="ContractRefNum" id="ContractRefNum" readOnly />

                            </div>
                        </div>

                        <div className="form-format ws-12">
                            <label className="control-label">Note Details</label>
                            <div className="label-entries">

                                <div className="controls">
                                    <textarea rows={10} maxLength={2000} placeholder="Note Details" value={noteDetails?.contractNotes ?? ""}
                                        onChange={(e: any) => setnoteDetails({ ...noteDetails, contractNotes: e.target.value })} id="contractNotes" ></textarea>
                                </div>

                            </div>
                        </div>

                        <div className="form-format ws-12">
                            <label className="control-label">Action Date</label>
                            <div className='w-90'>
                                <DatePickerRange onChange={actionDateSelection} type={"single"} data={noteDetails?.notesActionDate} />
                            </div>
                        </div>

                        <div className="form-format ws-12">
                            <label className="control-label">Start Date</label>
                            <div className='w-90'>
                                <DatePickerRange onChange={startDateSelection} type={"single"} data={noteDetails?.notesStartDate} />
                            </div>
                        </div>

                        <div className="form-format ws-12">
                            <label className="control-label">Contract Section</label>
                            <div className="label-entries">

                                <select onChange={(e: any) => setnoteDetails({ ...noteDetails, contractSection: e.target.value })} name="contractSection" id="contractSection" value={noteDetails.contractSection ?? ""}>
                                    <option value=""  >Choose Contract Section</option>
                                    <option value="RETENTIONS" label="RETENTIONS">RETENTIONS</option>
                                    <option value="AUDITS" label="AUDITS">AUDITS</option>
                                    <option value="ADVANCES" label="ADVANCES">ADVANCES</option>
                                    <option value="PAYMENTDATES" label="PAYMENTDATES">PAYMENTDATES</option>
                                    <option value="GENERAL" label="GENERAL">GENERAL</option>
                                </select>

                            </div>
                        </div>

                        <div className="form-format ws-12">
                            <label className="control-label">Notes Amount</label>
                            <div className="label-entries">
                                <input type="text" className="text-uppercase " value={noteDetails?.notesAmount ?? ""}
                                    placeholder="Notes Amount" onChange={(e: any) => setnoteDetails({ ...noteDetails, notesAmount: e.target.value })} name="notesAmount" id="notesAmount" />

                            </div>
                        </div>

                    </div>

                    <div className="box-footer">

                        <button className="icon-btn edit width70 height35" title="Save" onClick={() => SaveContractNote()}>
                            <i className="icon-save"></i> Save
                        </button>

                        <button className="icon-btn delete width70 height35" title="Reset" onClick={() => ResetContractNote()}>
                            <i className="icon-refresh"></i> Reset
                        </button>

                    </div>

                    <div className="box mt">
                        <div className="box-header well">
                            <h2 ><i className="fa fa-table"></i> {contractNoteRow} record(s) found</h2>
                        </div>

                        <div className="box-content">
                            <div className="ws-12">
                                <ul className='nav nav-tabs p0 m0 mtl'>

                                    <li className={contractSectionType == "All" ? "active" : ""} onClick={() => loadContractNotes("All")}>
                                        All
                                    </li>
                                    <li className={contractSectionType == "RETENTIONS" ? "active" : ""} onClick={() => loadContractNotes("RETENTIONS")}>
                                        RETENTIONS
                                    </li>
                                    <li className={contractSectionType == "AUDITS" ? "active" : ""} onClick={() => loadContractNotes("AUDITS")}>
                                        AUDITS
                                    </li>
                                    <li className={contractSectionType == "ADVANCES" ? "active" : ""} onClick={() => loadContractNotes("ADVANCES")}>
                                        ADVANCES
                                    </li>
                                    <li className={contractSectionType == "PAYMENTDATES" ? "active" : ""} onClick={() => loadContractNotes("PAYMENTDATES")}>
                                        PAYMENTDATES
                                    </li>
                                    <li className={contractSectionType == "GENERAL" ? "active" : ""} onClick={() => loadContractNotes("GENERAL")}>
                                        GENERAL
                                    </li>

                                </ul>
                            </div>

                            {(contractNoteRow == 0) && <div className="alert alert-info mtl" >No records to display   </div>}

                            {contractNoteRow > 0 && <div className='ws-12'>

                                <div className="form-format ws-10 "  >
                                    <label className="control-label form-condensed"  >Filter</label>
                                    <div className="label-entries">
                                        <input type="text" className="span4 form-control" placeholder="Search" id="filterTbl" onChange={(e: any) => filterSearch(e.target.value)} />
                                    </div>
                                </div>

                                <div className="ws-12 ">
                                    <div className=" ws-12 allowHscroll allowVscroll">
                                        <table className="NewTable ">
                                            <thead>
                                                <tr>
                                                    <th className='forceSingleLine'>Contract Ref No.</th>
                                                    <th className='forceSingleLine'>Contract Clause</th>
                                                    <th className='forceSingleLine'>Contract Notes</th>
                                                    <th className='forceSingleLine'>Contract Section</th>
                                                    <th className='forceSingleLine'>Entry Date</th>
                                                    <th className='forceSingleLine'>Notes Amount</th>
                                                    <th className='forceSingleLine'>Action Date</th>
                                                    <th className='forceSingleLine'>Start Date</th>
                                                    <th className='width100'>Operations</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    contractNoteList?.map((list: any) => {
                                                        return (

                                                            <tr>
                                                                <td>{list?.contractRefNum}</td>
                                                                <td>{list?.contractClause}</td>
                                                                <td>{list?.contractNotes}</td>
                                                                <td>{list?.contractSection}</td>
                                                                <td>{Filter.monthAndDayYear(list?.entryDate)}</td>
                                                                <td>{list?.notesAmount}</td>
                                                                <td>{Filter.monthAndDayYear(list?.notesActionDate)}</td>
                                                                <td>{Filter.monthAndDayYear(list?.notesStartDate)}</td>
                                                                <td>
                                                                    <div className='width90'>
                                                                        <button className="icon-btn edit" title="Edit" type="button" onClick={() => editContractNote(list)}>
                                                                            <i className="icon-pencil"> </i>
                                                                        </button>

                                                                        <button className="icon-btn delete" title="Delete" type="button" onClick={() => deleteContractNote(list)}>
                                                                            <i className="icon-trash"> </i>
                                                                        </button>

                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="clearfix">
                                        {(() => {
                                            if (contractNoteRow && contractNoteRow > 10) {
                                                return <Pagination onPageChange={handleNameOnChange} totalRow={contractNoteRow} />;
                                            }

                                        })()}
                                    </div>
                                </div>

                            </div>}
                        </div>

                        <div className="box-footer">
                            <button className="icon-btn delete width80 height35 pull-right" onClick={closeDrawer}><i className="fa fa-close"></i> Close
                            </button>
                        </div>
                    </div>

                    {
                        (() => {

                            if (deleteNoteStatus) {
                                return <DeleteDialogueBox param={true} message={"delete the following: " + deleteNoteData?.contractClause} onChange={Confirmation} />
                            }
                        })()
                    }

                </div>



            </Drawer >
        </>

    )


}